export const baseBeneficiaryListingColumns = [
  {
    label: 'Beneficiary Name',
    value: 'beneficiary-name',
    handleBarKey: `{{ name }}`,
    selected: true,
  },
  {
    label: 'Account Number / IBAN',
    value: 'account-number',
    handleBarKey: `{{#if destinationIdentifier.accountNumber}}{{destinationIdentifier.accountNumber}}{{else if destinationIdentifier.iban}}{{destinationIdentifier.iban}}{{else}}--{{/if}}`,
    selected: true,
  },
  {
    label: 'Currency',
    value: 'currency',
    handleBarKey: '{{ destinationIdentifier.currency }}',
    selected: true,
  },
  {
    label: 'Country',
    value: 'country',
    handleBarKey: '{{ countryFullName destinationIdentifier.country }}',
    selected: true,
  },
  {
    label: 'Routing Details',
    value: 'routing-details',
    handleBarKey: `{{getRoutingDetail destinationIdentifier}}`,
    selected: true,
  },
  {
    label: 'SWIFT / BIC',
    value: 'swift-bic',
    handleBarKey: `{{#if destinationIdentifier.bic}}{{destinationIdentifier.bic}}{{else}}--{{/if}}`,
    selected: true,
  },
];
